<template>
    <transition :name="transitionName" appear>
        <div class="section">
            <slot name="header"></slot>
            <div class="section-content">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        transitionName: {
            type: String,
            default: 'section'
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$section-width = 960px //820px //calc(100% - 268px)

.section
    position absolute
    top 0
    left 0
    display flex
    width 100%
    height 100%
    box-sizing border-box
    overflow-y overlay
    scrollbar()

    @media screen and (max-width: $mobile-step1-max-width)
        margin-left 0
        width 100%

    header
        justify-content space-between !important
        z-index 3000 !important

    header > section
        justify-content space-between !important
        width 100%
        display flex

    & > .section-content
        position absolute
        top 0
        left 50%
        transform translateX(-50%)
        display flex
        // width 100%
        // max-width $section-width
        width 100%
        max-width 1200px
        justify-content center
        padding-top 128px
        padding-bottom 48px
        padding-left 108px
        padding-right 108px
        flex-direction column
        box-sizing border-box

        @media screen and (max-width: $mobile-step1-max-width)
            padding-top 114px
            padding-bottom 24px
            padding-left 64px
            padding-right 64px

        @media screen and (max-width: $mobile-step2-max-width)
            padding-top 114px
            padding-bottom 24px
            padding-left 34px
            padding-right 34px

        @media screen and (max-width: $mobile-step3-max-width)
            padding-top 114px
            padding-bottom 14px
            padding-left 14px
            padding-right 24px

        .section-warning
            padding 20px
            color white
            background-color $color-red-1
            margin-bottom 40px
            text-align center
            border-radius 4px

            &.bottom
                margin-top 40px
                margin-bottom 0px

    &.fullscreen
        // position fixed
        width 100%
        margin-left 0
        top 0
        height 100%

        & > .section-content
            width 100%
            max-width 100%
            padding 0
            margin 0
            height calc(100% - 54px)
            top 54px
            left 0
            transform none
            justify-content flex-start
            overflow hidden

        header
            min-height 54px
            height 54px
            width 100%
            flex 0 0 48px
            background-color white
            display flex
            justify-content flex-start
            align-items center
            padding 0 14px
            position absolute
            top 0
            left 0
            z-index 10
            box-sizing border-box

        &.sub-fullscreen

            & > .section-content
                top 0
                height 100%

    &.sub-section
        margin 0
        width 100%
        display flex
        justify-content center
        align-items center
        flex-direction row
        padding-top 54px
        padding-bottom 54px
        flex-wrap wrap

        & > .section-content
            position relative
            max-width 820px
            height fit-content
            justify-content center
            overflow initial
            top 0

</style>



// WEBPACK FOOTER //
// src/components/v3/section/Section.vue